<template>
  <div class="file-uploader">
    {{ messages['dragFileToThis'] }}:
    <button class="btn btn-lg btn-primary" v-on:click="triggerUploaderClick()">{{ messages['uploadFile'] }}
    </button>
    <div class="alert alert-danger" v-bind:class="{ 'show': hasError }">
      {{ messages['file'] }} «{{ fileNameWithError }}» {{ messages['fileIsLarger'] }}.
    </div>
    <form enctype="multipart/form-data" method="POST">
      <input
        accept="application/msword,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx,application/pdf,.pdf"
        hidden="hidden"
        multiple
        name="filename" type="file"/>
    </form>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
import axios from 'axios'

export default {
  name: 'FileUploader',
  props: [
    'messages',
    'callback'
  ],
  data () {
    const uploader = null
    const hasError = false
    const fileNameWithError = ''

    return {
      uploader,
      hasError,
      fileNameWithError
    }
  },
  mounted () {
    this.$el.addEventListener('dragenter', this.over, false)
    this.$el.addEventListener('dragover', this.over, false)
    this.$el.addEventListener('dragleave', this.leave, false)
    this.$el.addEventListener('drop', this.leave, false)

    this.$el.addEventListener('drop', this.handleFiles, false)

    const self = this
    const inputs = this.$el.getElementsByTagName('input')
    if (inputs.length > 0) {
      this.uploader = inputs[0]
      // noinspection JSUnresolvedFunction
      this.uploader.addEventListener('change', function () {
        self.fileUploaderInputChange()
      })
    }
  },
  methods: {
    triggerUploaderClick () {
      if (this.uploader == null) {
        return
      }
      this.hasError = false

      // noinspection JSUnresolvedFunction
      this.uploader.click()
    },
    fileUploaderInputChange () {
      if (this.uploader == null) {
        return
      }

      // noinspection JSUnresolvedVariable
      const files = this.uploader.files
      if (files.length === 0) {
        return
      }

      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        formData.append('files', file)
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      axios.post('/rest/v1/files', formData, config).then(_ => {
      }, _ => {
      })

      this.uploader.value = ''
    },
    over (e) {
      e.preventDefault()
      e.stopPropagation()

      this.$el.classList.add('highlight')
    },
    leave (e) {
      e.preventDefault()
      e.stopPropagation()

      this.$el.classList.remove('highlight')
    },
    handleFiles (e) {
      this.hasError = false
      const dt = e.dataTransfer
      const files = dt.files

      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        formData.append('files', file)
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      axios.post('/rest/v1/files', formData, config).then(_ => {
      }, _ => {
      })
    }
    /* uploadFile (file) {
      const self = this
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = function () {
        if (reader.result.length > 400000) {
          self.hasError = true
          self.fileNameWithError = file.name
          return
        }
        /!* self.callback.invokeMethodAsync('TestMethod', reader.result)
          .then(r => console log(r)) *!/
        // console log(reader.result)
        // noinspection JSUnresolvedFunction
        self.callback.invokeMethodAsync('UploadFile', reader.result)
        // .then(r => console log(r))
      }
    } */
  }
}
</script>
